import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { SharedModule } from 'eddydata-lib';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { ReceitaNivelRoutingModule } from './receita-nivel-routing.module';
import { ReceitaNivelComponent } from './receita-nivel.component';


@NgModule({
  declarations: [
    ReceitaNivelComponent,
  ],
  imports: [
    CommonModule,
    ReceitaNivelRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    CalendarModule,
    IMaskModule,
    ToastModule,
  ],
  exports: [
    ReceitaNivelComponent
  ]
})
export class ReceitaNivelModule { }
